export default __webpack_public_path__ + "static/media/logo.d0531bf4.png";